module.exports = __webpack_public_path__ + "img/grid.e0d07771.svg";